var get = require("object-path").get;

/**
 * Determines the position from which to start media playback.
 *
 * @param    {Object}  session  The watching session
 * @param    {Object}  media    The media item
 * @param    {Object}  asset    The media asset
 * @param    {Object}  params   Optional request parameters
 * @returns  {number}  The start position.
 * @private
 */
module.exports = function(session, media, asset, params) {
    var sessionCursor = get(session, "cursor", 0),
        paramsCursor  = get(params, "cursor", null),
        duration      = get(asset, "duration", 0),
        cursor,
        setup         = {};

    switch (get(media, "type", null)) {
        case "audio":
        case "album_track":
            cursor = paramsCursor !== null
                ? parseInt(paramsCursor, 10)
                : 0;
            break;
        default:
            cursor = paramsCursor !== null
                ? parseInt(paramsCursor, 10)
                : parseInt(sessionCursor, 10);
            break;
    }

    setup.offsetStartPosition = cursor >= 5 && cursor < duration - 10
        ? cursor * 1000
        : 0;

    return setup;
};
